import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { SystemNoteEdit } from '../model/systemNoteEdit';
import { merge } from 'lodash';

@Component({
  selector: 'app-system-note-edit',
  templateUrl: './system-note-edit.component.html',
  styleUrls: ['./system-note-edit.component.scss']
})
export class SystemNoteEditComponent
{
  @Input() public isNew = false;

  @Output() public cancelling: EventEmitter<any> = new EventEmitter();
  @Output() public save: EventEmitter<SystemNoteEdit> = new EventEmitter();

  public editForm: any;
  public editFormActive = false;

  private systemNoteEdit: SystemNoteEdit;

  constructor(
    private fb: UntypedFormBuilder)
  {
  }

  public get text(): UntypedFormControl
  {
    return this.editForm.get('text');
  }

  @Input() public set model(systemNote: SystemNoteEdit)
  {
    this.initModel(systemNote);
  }

  public onSave(e: Event): void
  {
    e.preventDefault();

    const objectToPersist = merge(this.systemNoteEdit, this.editForm.value);

    this.save.emit(objectToPersist);
    this.editFormActive = false;
  }

  public onCancel(e: Event): void
  {
    e.preventDefault();
    this.closeEditForm();
  }

  private closeEditForm(): void
  {
    this.editFormActive = false;
    this.cancelling.emit();
  }

  private initModel(systemNote: SystemNoteEdit)
  {
    if (systemNote === undefined)
    {
      return;
    }

    // Set form
    this.editForm = this.fb.group({
      id: [null],
      text: [
        { value: '', disabled: false }, Validators.required
      ]
    });

    this.editForm.reset(systemNote);
    this.systemNoteEdit = systemNote;
    this.editFormActive = systemNote !== undefined;
  }
}
